/**
 * Hues.js — Core barrel
 * -----------------------------------------------------------------------------
 * Public entry point for the Hues.js core view layer. Re-exports the
 * reactivity primitives, the virtual DOM, the component system, and the
 * template compiler.
 *
 * © Death Legion — Hues.js
 */

export * from './reactivity'
export * from './vdom'
export * from './component'
export * from './compiler'
export * from './directives'

// Convenience: package version
export const HUES_VERSION = '1.0.0'
export const HUES_AUTHOR = 'Death Legion'
